import { env } from "next-runtime-env";
export const NEXT_PUBLIC_HEMIDAL_URL =
  process.env.NEXT_PUBLIC_HEMIDAL_URL || env("NEXT_PUBLIC_HEMIDAL_URL");
export const NEXT_PUBLIC_BASE_URL =
  process.env.NEXT_PUBLIC_BASE_URL || env("NEXT_PUBLIC_BASE_URL");
export const NEXT_PUBLIC_DISABLE_REGISTERATION =
  process.env.NEXT_PUBLIC_DISABLE_REGISTERATION ||
  env("NEXT_PUBLIC_DISABLE_REGISTERATION");
